export default {"src":"/_next/static/media/stakeholder_engagement_csrd_alignment_analysis.4333657f.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};